import baseService from './baseService';
import config from '../../config';

export default{

    getById(id){
        return baseService.get(config.API_LOCATION + 'building/' + id,{})
    }

}

